import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import SettingsStore from "@/stores/SettingsStore";
import { useTranslation } from "react-i18next";
import { ControlWrapper } from "@/components/ui/control-wrapper";

export function MessagesToggle() {
  const { t } = useTranslation();
  const displayMessages = SettingsStore(state => state.displayMessages);
  const setDisplayMessages = SettingsStore(state => state.setDisplayMessages);
  const isLoading = SettingsStore(state => state.isLoading);

  return (
    <ControlWrapper>
      <div className="flex items-center justify-between">
        <Label htmlFor="display-messages">{t("settings.displayMessages")}</Label>
        <Switch
          id="display-messages"
          checked={displayMessages}
          onCheckedChange={setDisplayMessages}
          disabled={isLoading}
        />
      </div>
    </ControlWrapper>
  );
}
